import { FC } from "react";
import { ChildrenProps } from "types/childrenProps.type";

export const H2: FC<ChildrenProps> = ({ children }) => (
  <h3 className="text-base font-semibold leading-6 text-gray-900">
    {children}
  </h3>
);
